module.exports = __webpack_public_path__ + "img/Landing Photo 2.2fde88a8.jpg";